// Invitaciones a jugadores.

import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from '../query-client';
import {
  Tournament,
  TournamentPlayer,
  UserWithToken,
  WithData,
} from '../api.types';
import { USER_BASIC_FIELDS } from '../fragments';

export const getMyTournamentInvitations = async (user: UserWithToken) =>
  getGraphQLQueryClient(user).request<{
    data: Array<TournamentPlayer & { tournament: Tournament }>;
  }>(
    gql`
      ${USER_BASIC_FIELDS}
      query myTournamentInvitations {
        data: myTournamentInvitations {
          id
          status
          invitedByOrganizer
          user {
            ...UserBasicFields
          }
          tournament {
            id
            title
            dateFrom
            dateTo
            status
            location {
              id
              name
              city
            }
            organizer {
              id
              name
              logoUrl
            }
          }
        }
      }
    `
  );

export const respondTournamentInvitation = async (
  user: UserWithToken,
  tournamentId: number,
  accept: boolean
) =>
  getGraphQLQueryClient(user).request<WithData<TournamentPlayer>>(
    gql`
      mutation respondTournamentInvitation(
        $tournamentId: Int!
        $accept: Boolean!
      ) {
        data: respondTournamentInvitation(
          tournamentId: $tournamentId
          accept: $accept
        ) {
          id
          status
        }
      }
    `,
    { tournamentId, accept }
  );
